/**
 * Constructs an object with basic vehicle details from a MyCars item, using a VIN as lookup.
 *
 * @param matcher an item UUID or vin to match a vehicle on
 * @returns {object}
 */
const getMyCarsVehicleFromVinOrId = (matcher, myCars) => {
	const {
		viewedVehicles = [],
		savedVehicles = [],
		priceChangeVehicles = []
	} = myCars || {};
	const vehicles = [
		...viewedVehicles,
		...savedVehicles,
		...priceChangeVehicles
	];

	return (
		vehicles.find(
			(vehicle) =>
				vehicle?.attributes?.vin === matcher ||
				vehicle?.itemUUID === matcher
		)?.attributes || {}
	);
};

export default getMyCarsVehicleFromVinOrId;
